import { render, staticRenderFns } from "./FourNurseDialog.vue?vue&type=template&id=ddc9f79e&scoped=true&"
import script from "./FourNurseDialog.vue?vue&type=script&lang=ts&"
export * from "./FourNurseDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FourNurseDialog.vue?vue&type=style&index=0&id=ddc9f79e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc9f79e",
  null
  
)

export default component.exports